import { StateCreator } from 'zustand';
import { Store } from '../store.interface';
import { AttributeManagementStore } from './attributeManagementStore.interface';
import { ATTRIBUTE_ROUTES, AttributeRouteType } from '../../components/AttributeManagement/navigation/types/navigationTypes';

export const defaultAttributeManagementStore = {
	attributeCurrentView: ATTRIBUTE_ROUTES.ATTRIBUTES,
	selectedAttribute: null,
	attributeNavigationErrors: [],
};

const attributeManagementStore: StateCreator<Store, [], [], AttributeManagementStore> = (set, get) => ({
	...defaultAttributeManagementStore,

	setAttributeCurrentView: (view: AttributeRouteType) => set({ attributeCurrentView: view }),

	setSelectedAttribute: (attribute) => set({ selectedAttribute: attribute }),

	addAttributeNavigationError: (error) => {
		const id = `attr-nav-error-${Date.now()}-${Math.random()}`;
		const newError = { ...error, id };

		set({ attributeNavigationErrors: [...get().attributeNavigationErrors, newError] });
	},

	clearAttributeSelections: () =>
		set({
			selectedAttribute: null,
			attributeNavigationErrors: [],
		}),
});

export default attributeManagementStore;
